export const ASSESSMENT_DETAILS_REQUEST = "ASSESSMENT_DETAILS_REQUEST";
export const ASSESSMENT_DETAILS_RECEIVE = "ASSESSMENT_DETAILS_RECEIVE";
export const ASSESSMENT_DETAILS_FAILURE = "ASSESSMENT_DETAILS_FAILURE";
export const RESET_ASSESSMENT_DETAILS = "RESET_ASSESSMENT_DETAILS";
